import React, { useEffect } from 'react';
import './index.less';

const PageNcov = props => {
  const { anchor } = props;

  let ele = document.getElementById('enterNcov');
  useEffect(() => {
    if (ele) {
      ele.addEventListener('mouseover', enter);
      ele.addEventListener('mouseout', out);
    }
  }, [ele])
  const enter = () => {
    ele.style.cssText = 'transform:scale(1.05) !important;transition:all 0.4s linear;';
  }
  const out = () => {
    ele.style.cssText = 'transform:scale(1) !important;transition:all 0.4s linear;';
  }
  return (
    <div className='pageNcov'>
      <div className='partner_title'>
          应用案例
        </div>
      <div className="contents">
        <div className="scholar_left">
          <div className='scholar_left_img'>
            <img src='/assets/ncov_img.png' style={{ width: `${anchor.scale * 900}px`, minWidth: 300 }} />
          </div>
        </div>
        <div className="scholar_right">
          <div className='scholar_right_img'>
            <div style={{ marginBottom: `${anchor.isMobile ? 14 : 20}px` }}>
              <img src='/assets/ncov.png' style={{ width: `${anchor.scale * 92}px`, minWidth: 50 }} />
            </div>
            <div>
              <img src='/assets/ncov1.png' style={{ width: `${anchor.scale * 368}px`, minWidth: 150 }} />
            </div>
            <div className="right_btn">
              <div>
                <a href='http://university.zhipu.ai/hot/ncov' id='enterNcov' target="_block" >
                  点击进入
                </a>
              </div>
            </div>
          </div>
          {
              !!anchor.isMobile
              &&
              <img
                src='/assets/top_text_6.png'
                className='top_text_6'
                style={{ width: `${anchor.scale * 26}px`, minWidth: 16 }}
                />
            }
        </div>

      </div>
    </div>
  )
}

export default PageNcov;